module.exports = __webpack_public_path__ + "img/zip-file-icon.34de8571.svg";